import React from 'react';
import { IPagerProps } from './pager.types';
import styles from './pager.module.css';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import { Select } from 'shared-components';

export const Pager = ({
  page,
  perPage,
  totalPages,
  perPageOptions = [10, 25, 50, 100],
  onNext,
  onPrevious,
  onPageSelected,
  onPerPageChange,
}: IPagerProps) => {
  return (
    <div className={styles.pager}>
      {page > 1 && (
        <button
          onClick={() => {
            onPrevious?.();
          }}
          className={styles.previous}
        >
          <ChevronLeftIcon />
        </button>
      )}
      <Select
        onChange={(ev) => {
          onPageSelected?.(+ev.target.value);
        }}
        value={page}
      >
        {[...Array(totalPages).keys()].map((i) => (
          <option key={i} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </Select>
      <span>&nbsp;/&nbsp;{totalPages}&nbsp;|&nbsp;</span>
      <Select
        onChange={(ev) => {
          onPerPageChange?.(+ev.target.value);
        }}
        value={perPage}
        // defaultValue={perPage}
      >
        {perPageOptions.map((i) => (
          <option key={i} value={i}>
            {i}
          </option>
        ))}
      </Select>
      <span>&nbsp;per&nbsp;page</span>
      {page < totalPages && (
        <button
          onClick={() => {
            onNext?.();
          }}
          className={styles.next}
        >
          <ChevronRightIcon color="black" />
        </button>
      )}
    </div>
  );
};
